import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const SectionTitle = styled.h3`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
  margin: 0;
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RadioOption = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export const HiddenRadio = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 0;
  height: 0;
`;

export const RadioControl = styled.span`
  width: 14px;
  height: 14px;
  border-radius: 999px;
  border: 1.5px solid ${ColorV2.Blue5};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${ColorV2.White};

  ${RadioOption} ${HiddenRadio}:checked + & {
    border-color: ${ColorV2.Blue1};
  }

  ${RadioOption} ${HiddenRadio}:checked + &::after {
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 999px;
    background: ${ColorV2.Blue1};
  }
`;

export const RadioLabel = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue1};
  min-width: 42px;
`;

export const RadioDescription = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;

export const FooterRow = styled.div`
  display: flex;
  justify-content: center;
`;

export const ErrorText = styled.div`
  ${TypographyV2.s1};
  color: ${ColorV2.NegativeRed};
`;
